<template>
  <Breadcrumb></Breadcrumb>
  <RentalListingAgreementForm :rentalListingAgreement="rentalListingAgreement" :title="$gettext('Nouvelle mission de location')" @submit="onSubmit" @cancel="onCancel" />
</template>

<script setup>
import { useRentalListingAgreementStore } from "@/stores/rentalListingAgreement";
import { useRouter } from "vue-router";
import RentalListingAgreementForm from "@/components/rental-listing-agreements/RentalListingAgreementForm.vue";
import Breadcrumb from "@/components/layout/BreadcrumbNavigation.vue";

const router = useRouter();
const rentalListingAgreementStore = useRentalListingAgreementStore();
const rentalListingAgreement = rentalListingAgreementStore.empty;

const onSubmit = (payload, actions) => {
  rentalListingAgreementStore.save(payload, (rentalListingAgreement) => {
    router.push({ name: "rental-listing-agreement", params: { id: rentalListingAgreement.id } });
  }, (errors) => {
    actions.setErrors(errors.value);
  });
};

const onCancel = () => {
  router.back();
};

</script>
